export const categories = [
  {
    id: 'today',
    name: '今日上新',
    slug: 'today',
    desc: '每天第一时间的瓜料与更新，早晚各一轮，热点不过夜。',
    icon: 'ri-flashlight-line',
    count: 2,
  },
  {
    id: 'weekly',
    name: '本周推荐',
    slug: 'weekly',
    desc: '编辑手工筛过的本周精选，只留值得花时间的那些。',
    icon: 'ri-medal-line',
    count: 2,
  },
  {
    id: 'weekend',
    name: '周末限定',
    slug: 'weekend',
    desc: '只在周末上线的内容与活动，把握两天的小确幸。',
    icon: 'ri-calendar-event-line',
    count: 2,
  },
  {
    id: 'holiday',
    name: '假日特辑',
    slug: 'holiday',
    desc: '长假与节假日专属企划，一次性把档期排明白。',
    icon: 'ri-gift-line',
    count: 2,
  },
  {
    id: 'hot',
    name: '近期热点',
    slug: 'hot',
    desc: '正在发酵的话题与全民热梗，跟上节奏不落伍。',
    icon: 'ri-fire-line',
    count: 2,
  },
];